(function () {

    'use strict';

    /**
     * Initiates the navigation.
     */
    const Navigation = function (element) {

        this.element = element;
        this.triggers = element.getElementsByTagName('BUTTON');

        this.presentNavigation = this.presentNavigation.bind(this);
        this.dismissNavigation = this.dismissNavigation.bind(this);

        this.initiateListener();
    }

    /**
     * Initiates the event listener.
     */
    Navigation.prototype.initiateListener = function () {

        this.triggers[0].addEventListener('pointerdown', this.presentNavigation);
        this.triggers[0].addEventListener('keydown', this.presentNavigation);

        this.triggers[1].addEventListener('pointerdown', this.dismissNavigation);
        this.triggers[1].addEventListener('keydown', this.dismissNavigation);
    }

    /**
     * Presents the navigation.
     */
    Navigation.prototype.presentNavigation = function (event) {

        for (const trigger of this.triggers) {
            trigger.setAttribute('aria-expanded', 'false');
        }

        event.target.setAttribute('aria-expanded', 'true');

        window.addEventListener('keyup', this.dismissNavigation);
        window.addEventListener('pointerdown', this.dismissNavigation);
    }

    /**
     * Dismisses the navigation.
     */
    Navigation.prototype.dismissNavigation = function (event) {

        let dismiss = false;

        if (event.type === 'keyup' && event.key === 'Escape') {
            dismiss = true;
        }

        if (event.type === 'keyup' && !event.target.closest('.js-main-nav')) {
            dismiss = true;
        }

        if (event.type === 'pointerdown' && event.target === this.triggers[1]) {
            dismiss = true;
        }

        if(event.type === 'pointerdown' && !event.target.closest('.js-main-nav')) {
            dismiss = true;
        }

        if (dismiss) {

            for (const trigger of this.triggers) {
                trigger.setAttribute('aria-expanded', 'false');
            }

            window.removeEventListener('keyup', this.dismissNavigation);
            window.removeEventListener('pointerdown', this.dismissNavigation);
        }
    }

    const navigations = document.getElementsByClassName('js-main-nav');

    for (const navigation of navigations) {
        new Navigation(navigation);
    }
}());